import axios from 'axios';

const baseUrl =
    process.env.NODE_ENV === 'production'
        ? `https://${process.env.REACT_APP_API_HOST}`
        : `http://${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}/api`;

const axiosInstance = axios.create({
    baseURL: baseUrl,
    headers: {
        // 'Content-Type': 'application/json',
    },
    timeout: 10000,
});

export default axiosInstance;
